/// <reference types="vite/client" />

interface ApiConfig {
  BASE_URL: string;
  WS_URL: string;
  TIMEOUT: number;
  ENDPOINTS: {
    LOGIN: string;
    LOGOUT: string;
    REFRESH_TOKEN: string;
    V2_LOGIN?: string;
    V2_REFRESH?: string;
    V2_ME?: string;
    V2_LOGOUT?: string;
    GET_VEHICLES: string;
    GET_COMPONENTS: string;
    GET_COMPONENT_CATEGORIES: string;
    GET_SKUS: string;
    SEARCH_SKUS: string;
    GET_WAREHOUSE_AREAS: string;
    GET_WAREHOUSE_AREA_BY_LOCATION: string;
    GET_COMPONENT_ASSOCIATIONS: string;
    GET_MODEL_ASSOCIATIONS: string;
    GET_VEHICLE_BODY_TYPES?: string;
    GET_SALES_REPORT: string;
    GET_RETURNS_REPORT: string;
    ADD_QUANTITY: string;
    SELL_PART_V2: string;
    GET_PRODUCT_ACTIVITIES: string;
    GET_SALE_PARTNERS: string;
    MANAGE_SALE_PARTNER_LISTING: string;
    GET_PRODUCT_LOCATIONS: string;
    GET_AI_RESEARCH: string;
    GET_SHEET_LABELS_LAZI: string;
    GENERATE_TEMPORARY_SKUS: string;
  };
  STORAGE_KEYS: {
    ACCESS_TOKEN: string;
    REFRESH_TOKEN: string;
    TOKEN_EXPIRY: string;
    USER_DATA: string;
  };
}

const API_CONFIG: ApiConfig = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || '',
  WS_URL: import.meta.env.VITE_WS_URL,
  TIMEOUT: 300000, // 5 minutes in milliseconds
  ENDPOINTS: {
    LOGIN: '/stoc/async/login',
    LOGOUT: '/stoc/async/logout',
    REFRESH_TOKEN: '/stoc/async/refresh-token',
    V2_LOGIN: '/stoc/auth/v2/login',
    V2_REFRESH: '/stoc/auth/v2/refresh',
    V2_ME: '/stoc/auth/v2/me',
    V2_LOGOUT: '/stoc/auth/v2/logout',
    GET_VEHICLES: '/stoc/async/vehicles',
    GET_COMPONENTS: '/stoc/async/components',
    GET_COMPONENT_CATEGORIES: '/stoc/async/component-categories',
    GET_SKUS: '/stoc/async/skus',
    SEARCH_SKUS: '/stoc/async/skus/search',
    GET_WAREHOUSE_AREAS: '/stoc/async/get_warehouse_areas',
    GET_WAREHOUSE_AREA_BY_LOCATION: '/stoc/async/get_warehouse_area',
    GET_COMPONENT_ASSOCIATIONS: '/stoc/async/component-associations',
    GET_MODEL_ASSOCIATIONS: '/stoc/async/model-associations',
    GET_VEHICLE_BODY_TYPES: '/crm/vehicle-catalog/body-types',
    GET_SALES_REPORT: '/stoc/async/sales-report',
    GET_RETURNS_REPORT: '/stoc/async/sales-report',
    ADD_QUANTITY: '/stoc/async/add-quantity',
    SELL_PART_V2: '/stoc/async/sell_part_v2',
    GET_PRODUCT_ACTIVITIES: '/stoc/async/product-activities',
    GET_SALE_PARTNERS: '/stoc/async/sale-partners',
    MANAGE_SALE_PARTNER_LISTING: '/stoc/async/manage-sale-partner-listing',
    GET_PRODUCT_LOCATIONS: '/stoc/async/sku-locations',
    GET_AI_RESEARCH: '/stoc/async/ai-research',
    GET_SHEET_LABELS_LAZI: '/stoc/async/sheet-labels/lazi',
    GENERATE_TEMPORARY_SKUS: '/stoc/async/temporary-skus/generate'
  },
  STORAGE_KEYS: {
    ACCESS_TOKEN: 'auth_token',
    REFRESH_TOKEN: 'refresh_token',
    TOKEN_EXPIRY: 'token_expiry',
    USER_DATA: 'user_data'
  }
};

export default API_CONFIG; 